import './App.css';
import Home from './Pages/Home';
import About from './Pages/About';
import Blogs from './Pages/Blogs';
import { Routes, Route } from "react-router-dom";
import Fitness from './Pages/Fitness';
import Car from './Pages/Car';
import Ladisbag from './Pages/Ladisbag';
import Navbar from './Pages/Navbar';

function App() {
  return (
    <div className="App">
       
       <Navbar></Navbar>
      
      <Routes>

    	  <Route path="/" element={<Home/>}></Route>
    	  <Route path="/about" element={<About></About>}></Route>
    	  <Route path="/blog" element={<Blogs></Blogs>}></Route>
        <Route path='/fitness' element={<Fitness></Fitness>}></Route>
        <Route path='/car' element={<Car></Car>}></Route>
        <Route path='/ladiesbag' element={<Ladisbag></Ladisbag>}></Route>
        
      </Routes>

    </div>
  );
}

export default App;
